export enum TimeframeFilters {
  ALL_WEEKS = 'all_weeks',
  THIS_WEEK = 'this_week',
  NEXT_WEEK = 'next_week',
  NEXT_WEEKS = 'next_weeks',
  PAST_WEEKS = 'past_weeks',
}

export enum TimeframeMonthFilters {
  THIS_MONTH = 'this_month',
  NEXT_MONTH = 'next_month',
  NEXT_MONTHS = 'next_months',
  PAST_MONTHS = 'past_months',
  LAST_MONTH = 'last_month',
}

export enum TimeframeUserFilters {
  THIS_MONTH = 'this_month',
  LAST_MONTH = 'last_month',
  PAST_MONTHS_2 = 'past_months_2',
  PAST_MONTHS_3 = 'past_months_3',
  PAST_MONTHS_6 = 'past_months_6',
  PAST_YEAR = 'past_year',
}

export enum StateFilters {
  PENDING = 'PENDING',
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  ALL = 'ALL',
}

export const TimeframeFiltersValues = {
  this_week: 1,
  next_week: 2,
  next_weeks: 4,
  past_weeks: -4,
};

export const TimeframeMonthFiltersValues = {
  this_month: 1,
  next_month: 2,
  next_months: 3,
  past_months: -3,
  last_month: -1,
};

export const TimeframeUserFiltersValues = {
  this_month: 1,
  last_month: -1,
  past_months_2: -2,
  past_months_3: -3,
  past_months_6: -6,
  past_year: -1,
};

export const timeframes: TimeframeFilters[] = Object.values(TimeframeFilters);
export const timeframesMonth: TimeframeMonthFilters[] = Object.values(
  TimeframeMonthFilters,
);
export const timeframesUser: TimeframeUserFilters[] =
  Object.values(TimeframeUserFilters);

export const states: StateFilters[] = Object.values(StateFilters);
